import { GridItem } from '@jouzen/ecom-components/v3/GridItem';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useTranslations } from 'next-intl';

import Image from '@/app/components/Image';

import { APPS_DATA } from './data';

const AppsThatIntegrate = () => {
  const t = useTranslations();
  return (
    <section>
      <LayoutGrid className="pt-20">
        <Typography
          Element="h3"
          variant="h4"
          className="col-main text-left md:text-center"
        >
          {t('developer_integrate_title')}
        </Typography>
        <GridItem
          colEnd={{ sm: 'main' }}
          colStart={{ sm: 'main' }}
          className="flex flex-col items-center gap-y-8 py-10 md:flex-row lg:gap-x-4 lg:gap-y-0"
        >
          {APPS_DATA.map(({ id, image }) => (
            <div
              key={id}
              className="p-4 sm:max-w-[262px] md:mb-16 md:w-1/2 md:max-w-none md:py-0 lg:mb-0 lg:w-1/4"
            >
              <div className="mb-5">
                <Image
                  alt={image.alt}
                  className="mx-auto"
                  src={image.src}
                  height={168}
                  width={232}
                />
              </div>
            </div>
          ))}
        </GridItem>
      </LayoutGrid>
    </section>
  );
};

export default AppsThatIntegrate;
